import * as Yup from 'yup'
import i18next from 'i18next'
import { isPossiblePhoneNumber } from 'react-phone-number-input'

import { urlRegex, noSpecialCharacterRegex, intlMobileNumber, leadingOnlyOneZero } from './regex'
import { sentenceFormat } from './string'

export const getValidationMessages = () => ({
  ACCOUNT_LOCKED_MINUTES: 'account_lock',
  ACCOUNT_LOCKED_SECONDS: 'account_lock_zero_minutes_msg',
  DUPLICATE_DOMAIN: sentenceFormat(i18next.t('validation_duplicated', { name: '$t(domain)' })),
  DUPLICATED_EMAIL: sentenceFormat(i18next.t('validation_duplicated', { name: '$t(email_lbl)' })),
  DUPLICATED_FIELD_NAME: sentenceFormat(i18next.t('validation_duplicated', { name: '$t(field_name_lbl)' })),
  DUPLICATED_NAME: sentenceFormat(i18next.t('validation_duplicated', { name: '$t(name_lbl)' })),
  DUPLICATED_TEAM_NAME: sentenceFormat(i18next.t('validation_duplicated', { name: '$t(team_name_lbl)' })),
  DUPLICATED_USER_PROFILE_NAME: sentenceFormat(i18next.t('validation_duplicated', { name: '$t(user_profile_name)' })),
  LATITUDE_TYPE_ERROR: sentenceFormat(i18next.t('validation_number', { name: '$t(latitude_lbl)' })),
  LONGITUDE_TYPE_ERROR: sentenceFormat(i18next.t('validation_number', { name: '$t(longitude_lbl)' })),
  REQUIRED_ADDRESS: sentenceFormat(i18next.t('validation_required', { name: '$t(address_lbl)' })),
  REQUIRED_ASSIGNEE: sentenceFormat(i18next.t('select_placeholder', { name: '$t(assignee_lbl)' })),
  REQUIRED_ATTENTION: sentenceFormat(i18next.t('select_placeholder', { name: '$t(attention)' })),
  REQUIRED_BRANCH: sentenceFormat(i18next.t('select_placeholder', { name: '$t(branch_lbl)' })),
  REQUIRED_BILLING_CYCLE: sentenceFormat(i18next.t('validation_required', { name: '$t(billing_cycle_lbl)' })),
  REQUIRED_CALL_OUTCOME: sentenceFormat(i18next.t('validation_required', { name: '$t(call_outcome_lbl)' })),
  REQUIRED_CALL_STATUS: sentenceFormat(i18next.t('validation_required', { name: '$t(call_status_lbl)' })),
  REQUIRED_CALL_TIME: sentenceFormat(i18next.t('validation_required', { name: '$t(call_time)' })),
  REQUIRED_CLOSING_DATE: sentenceFormat(i18next.t('validation_required', { name: '$t(closing_date_lbl)' })),
  REQUIRED_CLOSE_REASON: sentenceFormat(i18next.t('select_placeholder', { name: '$t(lost_reason)' })),
  REQUIRED_COLORS: sentenceFormat(i18next.t('validation_required', { name: '$t(colors_title)' })),
  REQUIRED_COMPANY: sentenceFormat(i18next.t('validation_required', { name: '$t(company_name_lbl)' })),
  REQUIRED_CUSTOMER_CONFIRMATION: sentenceFormat(
    i18next.t('validation_required', { name: '$t(customer_confirmation_lbl)' }),
  ),
  REQUIRED_CUSTOM_FIELD: sentenceFormat(i18next.t('validation_required', { name: '$t(custom_field)' })),
  REQUIRED_CONDITION_TYPE: sentenceFormat(i18next.t('validation_required', { name: '$t(user_confirmation)' })),
  REQUIRED_CONTACT: sentenceFormat(i18next.t('select_placeholder', { name: '$t(contact_lbl)' })),
  REQUIRED_CONTACT_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(contact_name_lbl)' })),
  REQUIRED_CONTACT_INFO_TYPE: sentenceFormat(i18next.t('select_placeholder', { name: '$t(contact_info_type)' })),
  REQUIRED_CONTRACT_LENGTH: sentenceFormat(i18next.t('validation_required', { name: '$t(contract_length_lbl)' })),
  REQUIRED_CONTRACT_START: sentenceFormat(i18next.t('validation_required', { name: '$t(contract_start)' })),
  REQUIRED_COUNTRY: sentenceFormat(i18next.t('validation_required', { name: '$t(country_lbl)' })),
  REQUIRED_COUNTRY_CODE: sentenceFormat(i18next.t('validation_required', { name: '$t(country_code)' })),
  REQUIRED_DATE_RANGE: sentenceFormat(i18next.t('validation_required', { name: '$t(start_date_and_end_date)' })),
  REQUIRED_DEPARTMENT: sentenceFormat(i18next.t('validation_required', { name: '$t(department_lbl)' })),
  REQUIRED_DESCRIPTION: sentenceFormat(i18next.t('validation_required', { name: '$t(description_lbl)' })),
  REQUIRED_DISPOSITION: sentenceFormat(i18next.t('validation_required', { name: '$t(disposition_lbl)' })),
  REQUIRED_DUE_DATE: sentenceFormat(i18next.t('select_placeholder', { name: '$t(due_date_lbl)' })),
  REQUIRED_DURATION: sentenceFormat(i18next.t('validation_required', { name: '$t(duration_lbl)' })),
  REQUIRED_EMAIL: sentenceFormat(i18next.t('validation_required', { name: '$t(email_address_lbl)' })),
  REQUIRED_FISCAL_YEAR: sentenceFormat(i18next.t('validation_required', { name: '$t(fiscal_year_lbl)' })),
  REQUIRED_FIELD: sentenceFormat(i18next.t('validation_required', { name: '$t(field)' })),
  REQUIRED_FIELD_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(field_name_lbl)' })),
  REQUIRED_FIELD_TYPE: sentenceFormat(i18next.t('select_placeholder', { name: '$t(field_type_lbl)' })),
  REQUIRED_FIRST_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(first_name_lbl)' })),
  REQUIRED_CUSTOM_FIELD_STARTING_NUMBER: sentenceFormat(
    i18next.t('validation_required', { name: '$t(custom_field_auto_number_starting_number_lbl)' }),
  ),
  REQUIRED_INDUSTRY: sentenceFormat(i18next.t('validation_required', { name: '$t(industry_lbl)' })),
  REQUIRED_ITEM: sentenceFormat(i18next.t('validation_required', { name: '$t(item_lbl)' })),
  REQUIRED_ITEM_TYPE: sentenceFormat(i18next.t('validation_required', { name: '$t(item_type)' })),
  REQUIRED_LAST_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(last_name_lbl)' })),
  REQUIRED_LEAD_IN_DATE: sentenceFormat(i18next.t('validation_required', { name: '$t(lead_in_date_lbl)' })),
  REQUIRED_LEAD_CAMPAIGN: sentenceFormat(i18next.t('validation_required', { name: '$t(lead_campaign_lbl)' })),
  REQUIRED_LEAD_CAMPAIGN_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(lead_campaign_name_lbl)' })),
  REQUIRED_LEAD_OWNER: sentenceFormat(i18next.t('validation_required', { name: '$t(lead_owner_lbl)' })),
  REQUIRED_LEAD_SOURCE: sentenceFormat(i18next.t('select_placeholder', { name: '$t(lead_source_lbl)' })),
  REQUIRED_LEAD_SOURCE_TYPE: sentenceFormat(i18next.t('select_placeholder', { name: '$t(lead_source_type)' })),
  REQUIRED_LEAD_STATUS: sentenceFormat(i18next.t('select_placeholder', { name: '$t(lead_status_lbl)' })),
  REQUIRED_LEAD_STATUS_GROUP: sentenceFormat(i18next.t('validation_required', { name: '$t(lead_status_group_lbl)' })),
  REQUIRED_LEAD_TYPE: sentenceFormat(i18next.t('validation_required', { name: '$t(lead_type_lbl)' })),
  REQUIRED_LOSS_REASON: sentenceFormat(i18next.t('select_placeholder', { name: '$t(loss_reasons_lbl)' })),
  REQUIRED_LOST_REASON: sentenceFormat(i18next.t('select_placeholder', { name: '$t(lost_reason_lbl)' })),
  REQUIRED_MASTER_ACCOUNT: sentenceFormat(i18next.t('select_placeholder', { name: '$t(master_account)' })),
  REQUIRED_LEAD_NAME: sentenceFormat(i18next.t('select_placeholder', { name: '$t(lead_search)' })),
  REQUIRED_MEETING_TYPE: sentenceFormat(i18next.t('validation_required', { name: '$t(meeting_type)' })),
  REQUIRED_MEETING_LOCATION_TYPE: sentenceFormat(
    i18next.t('validation_required', { name: '$t(meeting_location_type)' }),
  ),
  REQUIRED_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(name_lbl)' })),
  REQUIRED_OTP: sentenceFormat(i18next.t('validation_required', { name: 'OTP' })),
  REQUIRED_OPPORTUNITY_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(opportunity_name_lbl)' })),
  REQUIRED_OPPORTUNITY_OWNER: sentenceFormat(i18next.t('validation_required', { name: '$t(opportunity_owner_lbl)' })),
  REQUIRED_PASSWORD: sentenceFormat(i18next.t('validation_required', { name: '$t(password_lbl)' })),
  REQUIRED_PERIOD: sentenceFormat(i18next.t('validation_required', { name: '$t(period_lbl)' })),
  REQUIRED_PHONE_NUMBER: sentenceFormat(i18next.t('validation_required', { name: '$t(phone_number_lbl)' })),
  REQUIRED_POTENTIAL: sentenceFormat(i18next.t('validation_required', { name: '$t(potential_lbl)' })),
  REQUIRED_PRICE_CODE: sentenceFormat(i18next.t('validation_required', { name: '$t(price_code_lbl)' })),
  REQUIRED_PRICE_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(price_name_lbl)' })),
  REQUIRED_PRODUCT_GROUP: sentenceFormat(i18next.t('validation_required', { name: '$t(product_group)' })),
  REQUIRED_QUOTATION: sentenceFormat(i18next.t('validation_required', { name: '$t(quotation_lbl)' })),
  REQUIRED_REGISTRATION_NUMBER: sentenceFormat(i18next.t('validation_required', { name: '$t(reg_no_lbl)' })),
  REQUIRED_REJECT_REASON: sentenceFormat(i18next.t('validation_required', { name: '$t(reject_reason)' })),
  REQUIRED_SALES_OBJECTIVE: sentenceFormat(i18next.t('validation_required', { name: '$t(sales_objective)' })),
  REQUIRED_SALES_PIPELINE: sentenceFormat(i18next.t('validation_required', { name: '$t(sales_pipeline_lbl)' })),
  REQUIRED_SKU: sentenceFormat(i18next.t('validation_required', { name: '$t(sku_lbl)' })),
  REQUIRED_START_DATE: sentenceFormat(i18next.t('validation_required', { name: '$t(start_date_lbl)' })),
  REQUIRED_START_TIME: sentenceFormat(i18next.t('validation_required', { name: '$t(start_time_lbl)' })),
  REQUIRED_TASK_DESCRIPTION: sentenceFormat(
    i18next.t('validation_required', { name: '$t(bulk_task_update_description_lbl)' }),
  ),
  REQUIRED_TASK_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(task_name_lbl)' })),
  REQUIRED_TASK_TYPE: sentenceFormat(i18next.t('validation_required', { name: '$t(task_type_lbl)' })),
  REQUIRED_TAX: sentenceFormat(i18next.t('validation_required', { name: '$t(tax)' })),
  REQUIRED_TEAM_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(team_name_lbl)' })),
  REQUIRED_TIME_TO_CLOSE: sentenceFormat(i18next.t('validation_required', { name: '$t(timeline_to_close_lbl)' })),
  REQUIRED_TITLE: sentenceFormat(i18next.t('validation_required', { name: '$t(title_lbl)' })),
  REQUIRED_UNIT_PRICE: sentenceFormat(i18next.t('validation_required', { name: '$t(unit_price_lbl)' })),
  REQUIRED_USER_PERMISSION: sentenceFormat(i18next.t('validation_required', { name: '$t(user_permission_lbl)' })),
  REQUIRED_USER_PROFILE_NAME: sentenceFormat(i18next.t('validation_required', { name: '$t(user_profile_name)' })),
  REQUIRED_VALID_FROM: sentenceFormat(i18next.t('validation_required', { name: '$t(valid_from_lbl)' })),
  REQUIRED_VALIDITY: sentenceFormat(i18next.t('validation_required', { name: '$t(validity_lbl)' })),
  REQUIRED_VALIDITY_TYPE: sentenceFormat(i18next.t('validation_required', { name: '$t(validity_type)' })),
  REQUIRED_WEBSITE: sentenceFormat(i18next.t('validation_required', { name: '$t(website_lbl)' })),
  INVALID_EMAIL: sentenceFormat(i18next.t('validation_invalid', { name: '$t(email_address_lbl)' })),
  INVALID_CHARACTERS: 'invalid_characters_validation',
  INVALID_CONTRACT_END: sentenceFormat(i18next.t('validation_invalid', { name: '$t(contract_end)' })),
  INVALID_CONTRACT_START: sentenceFormat(i18next.t('validation_invalid', { name: '$t(contract_start)' })),
  INVALID_CONTRACT_RANGE: sentenceFormat(
    i18next.t('validation_date_range', { end: '$t(contract_end)', start: '$t(contract_end)' }),
  ),
  INVALID_DATE_RANGE: sentenceFormat(
    i18next.t('validation_date_range', { end: '$t(end_date_lbl)', start: '$t(start_date_lbl)' }),
  ),
  INVALID_DESCRIPTION: sentenceFormat(i18next.t('validation_invalid', { name: '$t(description_lbl)' })),
  INVALID_DOMAIN: sentenceFormat(i18next.t('validation_invalid', { name: '$t(domain)' })),
  INVALID_LEAD_IN_DATE_FUTURE: sentenceFormat(
    i18next.t('validation_invalid_future_date', { name: '$t(lead_in_date_lbl)' }),
  ),
  INVALID_NUM_EMPLOYEES: sentenceFormat(i18next.t('validation_invalid', { name: '$t(number_of_employees_lbl)' })),
  INVALID_PARENT_TEAM: sentenceFormat(i18next.t('validation_invalid', { name: '$t(paren_team)' })),
  INVALID_PHONE_NUMBER: sentenceFormat(i18next.t('validation_invalid', { name: '$t(phone_number_lbl)' })),
  INVALID_SIP: sentenceFormat(i18next.t('validation_invalid', { name: '$t(phone_sip_lbl)' })),
  INVALID_TASK_TYPE: sentenceFormat(i18next.t('validation_invalid', { name: '$t(task_type_lbl)' })),
  INVALID_URL: sentenceFormat(i18next.t('validation_invalid', { name: 'URL' })),
  INVALID_STRT_NUMBER: sentenceFormat(
    i18next.t('validation_invalid', { name: '$t(custom_field_auto_number_starting_number_lbl)' }),
  ),
  MAXIMUM_LENGTH_TEXT_AREA: 'max_lines_error',
  MAXIMUM_DATE_RANGE_30_DAYS: sentenceFormat(i18next.t('validation_date_range_max_days', { num: '30' })),
  MIN_CONDITION: sentenceFormat(i18next.t('validation_min', { min: 1, name: '$t(condition_lbl)' })),
  MIN_ITEM: sentenceFormat(i18next.t('validation_min', { min: 1, name: '$t(item_lbl)' })),
  MIN_PRICE: sentenceFormat(i18next.t('validation_min', { min: 1, name: '$t(price)' })),
  MIN_USER: sentenceFormat(i18next.t('validation_min', { min: 1, name: '$t(user_lbl)' })),
  NOT_ALLOW_SPECIAL_CHARACTER: 'invalid_characters_lbl',
})

export const containsValidCharactersAndPeriodOnly = (string: string) => /^[^\\\/:*?<>|]+$/.test(string)
export const containsValidCharactersOnly = (string: string) => /^[^\\\/:*?<>|.]+$/.test(string)
export const containsNumbersOnly = (string: string) => /^[0-9\b]+$/.test(string)
export const containsNumbersAndHyphensOnly = (string: string) => /^[0-9\b-]+$/.test(string)

/** Digits, spaces, and hyphens (relaxed numeric post codes, e.g. 12345, 12 345, 12345-6789) */
export const isRelaxedNumericPostCode = (value: string) => /^[0-9 -]+$/.test(value.trim())

/** Canadian format: A1A 1A1 or A1A1A1 (case-insensitive) */
export const isValidCanadianPostalCode = (value: string) =>
  /^[A-Za-z]\d[A-Za-z](?:[ -])?\d[A-Za-z]\d$/i.test(value.trim())

export const isValidPostCode = (value: string) => {
  const trimmed = value.trim()
  if (!trimmed) {
    return false
  }
  return isRelaxedNumericPostCode(trimmed) || isValidCanadianPostalCode(trimmed)
}

export const containsValidUrl = (string: string) => urlRegex.test(string)
export const isValidEmail = (value: string) => /^[-\w.]+@([\w-]+\.)+[\w-]{2,10}$/.test(value)
export const containsNoSpecialCharacter = (str: string) => noSpecialCharacterRegex.test(str)
export const isValidMobileNumber = (value: string) => /^\+?\d{5,20}$/.test(value)
export const isValidIntlMobileNumber = (value: string) => intlMobileNumber.test(value)
export const isLeadingOnlyOneZero = (value: string) => leadingOnlyOneZero.test(value)

export const nameValidation = (requiredErrMsg?: string) =>
  Yup.string()
    .required(requiredErrMsg)
    .test(
      'NOT_ALLOW_SPECIAL_CHARACTER',
      getValidationMessages().NOT_ALLOW_SPECIAL_CHARACTER,
      containsNoSpecialCharacter,
    )

export const EmailValidationFn = () =>
  Yup.object({
    value: Yup.string().test(
      'is-valid',
      getValidationMessages().INVALID_EMAIL,
      (value) => !value || isValidEmail(value),
    ),
  })

export const EmailValidation = Yup.object({
  value: Yup.string().test('is-valid', getValidationMessages().INVALID_EMAIL, (value) => !value || isValidEmail(value)),
})

export const EmailWithRequiredValidation = EmailValidation.concat(
  Yup.object({
    value: Yup.string()
      .required(getValidationMessages().REQUIRED_EMAIL)
      .test('is-valid', getValidationMessages().INVALID_EMAIL, (value) => !value || isValidEmail(value)),
  }),
)

export const getMobileNumberValidation = (isRequired = false) =>
  Yup.object({
    contactInfoTypeId: Yup.string().required(getValidationMessages().REQUIRED_CONTACT_INFO_TYPE),
    countryISO: Yup.string().required(getValidationMessages().REQUIRED_COUNTRY_CODE),
    value: Yup.string()
      .test(
        'is-valid-mobile',
        getValidationMessages().INVALID_PHONE_NUMBER,

        /**
         * Use isPossiblePhoneNumber instead of isValidPhoneNumber as per author suggested
         * https://catamphetamine.gitlab.io/react-phone-number-input/
         */
        (value) => !value || isPossiblePhoneNumber(value),
      )
      .when('number', (number, schema) => {
        if (!isValidIntlMobileNumber(number)) {
          return schema.matches(intlMobileNumber, getValidationMessages().INVALID_PHONE_NUMBER)
        }

        return schema
      })
      .when('required', (_, schema) =>
        isRequired ? schema.required(getValidationMessages().REQUIRED_PHONE_NUMBER) : schema.nullable(),
      ),
  })

export const NameValidation = Yup.string()
  .nullable()
  .test('containsValidCharactersOnly', getValidationMessages().INVALID_CHARACTERS, (value) =>
    containsValidCharactersOnly(value),
  )

export const ContactNameValidation = Yup.string()
  .nullable()
  .test('notOnlySpaces', getValidationMessages().REQUIRED_CONTACT_NAME, (value) => {
    // Treat null/undefined as valid (will be caught by required() if needed)
    if (!value) return true
    // Fail if string contains only whitespace
    return value.trim().length > 0
  })
  .test('containsValidCharactersOnly', getValidationMessages().INVALID_CHARACTERS, (value) =>
    containsValidCharactersOnly(value),
  )

export const getFirstErrorMessage = (err: string | string[] | Record<string, any>): string => {
  if (typeof err === 'object') {
    return getFirstErrorMessage(Object.values(err)[0])
  }

  if (Array.isArray(err)) {
    return getFirstErrorMessage(err[0])
  }

  return err
}
